import React from 'react';
import { CircularProgress, IconButton } from '@mui/material';
import CloseRoundedIcon from '@mui/icons-material/CloseRounded';
import { StyledPromoBanner } from './index.style';
import variants from './variants';

const PromoBanner = ({
  image,
  renderTitle,
  renderDescription,
  onClose,
  loading = false,
  actionButton,
  variant,
  showCloseButton = true,
  note,
  prefixConent,
}) => (
  <StyledPromoBanner metadata={variants[variant]}>
    <div style={{ display: 'flex', alignItems: 'center', gap: '16px' }}>
      {prefixConent || (
        <img
          className="banner-image"
          src={image}
          alt="studio-experience-banner"
        />
      )}
      <div className="banner-content">
        <div>{renderTitle}</div>
        {renderDescription && (
          <div className="banner-content-description">{renderDescription}</div>
        )}
      </div>
    </div>
    <div className="content-button-container">
      {loading ? (
        <CircularProgress
          value={75}
          className="circular-progress"
          size="24px"
        />
      ) : (
        actionButton
      )}
      {note}
      {showCloseButton && (
        <IconButton onClick={onClose}>
          <CloseRoundedIcon
            sx={{ color: '#1E164EA3' }}
            className="close-icon"
            onClick={onClose}
          />
        </IconButton>
      )}
    </div>
  </StyledPromoBanner>
);

export default PromoBanner;
